export const GIAOHANG_REPORT_LIST_INITING = 'GIAOHANG_REPORT_LIST_INITING'
export const GIAOHANG_REPORT_LIST_REQUESTING = 'GIAOHANG_REPORT_LIST_REQUESTING'
export const GIAOHANG_REPORT_LIST_SUCCESS = 'GIAOHANG_REPORT_LIST_SUCCESS'
export const GIAOHANG_REPORT_LIST_ERROR = 'GIAOHANG_REPORT_LIST_ERROR'

export const GIAOHANG_REPORT_LIST_NV_REQUESTING = 'GIAOHANG_REPORT_LIST_NV_REQUESTING'
export const GIAOHANG_REPORT_LIST_NV_SUCCESS = 'GIAOHANG_REPORT_LIST_NV_SUCCESS'
export const GIAOHANG_REPORT_LIST_NV_ERROR = 'GIAOHANG_REPORT_LIST_NV_ERROR'

export const GIAOHANG_REPORT_EXPORT_XLS_INITING = 'GIAOHANG_REPORT_EXPORT_XLS_INITING'
export const GIAOHANG_REPORT_EXPORT_XLS_REQUESTING = 'GIAOHANG_REPORT_EXPORT_XLS_REQUESTING'
export const GIAOHANG_REPORT_EXPORT_XLS_SUCCESS = 'GIAOHANG_REPORT_EXPORT_XLS_SUCCESS'
export const GIAOHANG_REPORT_EXPORT_XLS_ERROR = 'GIAOHANG_REPORT_EXPORT_XLS_ERROR'

export const GIAOHANG_REPORT_LIST_API = '/api/v1/giaohang/giaohang_report_list_by_store'
export const GIAOHANG_REPORT_LIST_NV_API = '/api/v1/giaohang/nhanvien_giaohang_list_by_store'
export const GIAOHANG_REPORT_EXPORT_API = '/api/v1/giaohang/giaohang_report_export_by_store'


// WEBPACK FOOTER //
// ./src/views/Reports/GiaoHangReport/constants.js